module.exports = __webpack_public_path__ + "img/plus-solid.c54d9f48.svg";